import { type Registry as Services, service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import uniqBy from 'lodash-es/uniqBy';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import BaseController from 'uplisting-frontend/pods/base/controller';
import PropertyTagModel from 'uplisting-frontend/models/property-tag';

export default abstract class SidebarController extends BaseController {
  @service storage!: Services['storage'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  @service('repositories/property-tag')
  propertyTagRepository!: Services['repositories/property-tag'];

  queryParams = ['from'];

  @tracked from!: string;

  @cached
  get properties(): ModelRegistry['property'][] {
    return this.propertyRepository.peekAll();
  }

  @cached
  get propertyTags(): ModelRegistry['property-tag'][] {
    return this.propertyTagRepository
      .peekAll()
      .filter((tag) => tag.properties.length);
  }

  @cached
  get selectedItems(): (
    | ModelRegistry['property']
    | ModelRegistry['property-tag']
  )[] {
    return [
      ...this.storage.propertiesConfigData.properties,
      ...this.storage.propertiesConfigData.propertyTags,
    ];
  }

  @cached
  get selectedProperties(): ModelRegistry['property'][] {
    const properties = this.selectedItems.flatMap((item) => {
      if (item instanceof PropertyTagModel) {
        return item.properties;
      }

      return item;
    });

    return uniqBy(properties, 'id');
  }

  @cached
  get selectedItemsIds(): string[] {
    return this.selectedProperties.map((property) => property.id);
  }
}
